import { render, staticRenderFns } from "./Accommodation-detail.vue?vue&type=template&id=2b4d17eb&scoped=true&"
import script from "./Accommodation-detail.vue?vue&type=script&lang=js&"
export * from "./Accommodation-detail.vue?vue&type=script&lang=js&"
import style0 from "./Accommodation-detail.vue?vue&type=style&index=0&id=2b4d17eb&scoped=true&lang=css&"
import style1 from "./Accommodation-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d17eb",
  null
  
)

export default component.exports